export default __webpack_public_path__ + "static/Крысиные бега_4-1772bfd1018ed540e2c16df56f3303af.jpg";